if (!customElements.get('ancillary-accordions')) {
  customElements.define(
    'ancillary-accordions',
    class AncillaryAccordions extends window.BAO.CustomElement() {
      setupListeners () {
        super.setupListeners()

        this.handleTrigger = this.handleTrigger.bind(this)

        this.listeners.add(this.els.items.element, 'click', this.handleTrigger)
      }

      handleTrigger (event) {
        const trigger = event.target.closest(
          `[data-ancillary-accordions-el="trigger"]`,
        )
        if (!trigger) return

        const accordionIndex = parseInt(trigger.dataset.index, 10)

        const currentItemElement = this.els.item.elements[accordionIndex]

        currentItemElement.style.setProperty(
          '--Max_Height',
          `${this.els.content.elements[accordionIndex].offsetHeight}px`,
        )
        currentItemElement.setAttribute(
          'aria-expanded',
          currentItemElement.getAttribute('aria-expanded') !== 'true',
        )
      }
    },
  )
}
